import React, { createContext, useContext, useReducer } from 'react';
import dynamic from 'next/dynamic';
import BaseContext from '../BaseContext';
const SearchBlock = dynamic(() => import('./SearchBlock'));
import { searchReducer, initialState } from '../../adapters/reducers/reducers';
const SearchComponent = props => {
  var _props$document;
  const document = props == null ? void 0 : (_props$document = props.document) == null ? void 0 : _props$document.fields;
  const [state, dispatch] = useReducer(searchReducer, initialState);
  return <div>
      <BaseContext value={[state, dispatch]}>
        <BaseContext.Consumer>
        {context => context && <>
        <SearchBlock document={document} context={context} />
        </>}
      </BaseContext.Consumer>
      </BaseContext>
  </div>;
};
export default React.memo(SearchComponent);